'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dMeal$002dO$002dRama$002dState from "./mealorama.-Meal-O-Rama-State.js";
var $p;
/** @constructor */
function $c_Lmealorama_MealORamaState$() {
  this.alV = null;
  $n_Lmealorama_MealORamaState$ = this;
  this.alV = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Ljapgolly_scalajs_react_feature_Context$$anon$3(($m_Lmealorama_MealORamaState$(), new $j_mealorama$002e$002dMeal$002dO$002dRama$002dState.$c_Lmealorama_MealORamaState(($m_Lmealorama_MealORamaState$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($m_Lmealorama_MealORamaState$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($m_Lmealorama_MealORamaState$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()), ($m_Lmealorama_MealORamaState$(), false), ($m_Lmealorama_MealORamaState$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$()))));
}
export { $c_Lmealorama_MealORamaState$ as $c_Lmealorama_MealORamaState$ };
$p = $c_Lmealorama_MealORamaState$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_MealORamaState$;
/** @constructor */
function $h_Lmealorama_MealORamaState$() {
}
export { $h_Lmealorama_MealORamaState$ as $h_Lmealorama_MealORamaState$ };
$h_Lmealorama_MealORamaState$.prototype = $p;
var $d_Lmealorama_MealORamaState$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_MealORamaState$, "mealorama.MealORamaState$", ({
  Gt: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_MealORamaState$ as $d_Lmealorama_MealORamaState$ };
var $n_Lmealorama_MealORamaState$;
function $m_Lmealorama_MealORamaState$() {
  if ((!$n_Lmealorama_MealORamaState$)) {
    $n_Lmealorama_MealORamaState$ = new $c_Lmealorama_MealORamaState$();
  }
  return $n_Lmealorama_MealORamaState$;
}
export { $m_Lmealorama_MealORamaState$ as $m_Lmealorama_MealORamaState$ };
//# sourceMappingURL=mealorama.-Meal-O-Rama-State$.js.map
